<!-- Expand Cell Template -->
<ng-template #assetRequestExpandCell let-row>
  <button 
    class="expand-btn"
    (click)="toggleRowExpansion(row)"
    [attr.aria-expanded]="isRowExpanded(row)"
    type="button"
  >
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      [style.transform]="isRowExpanded(row) ? 'rotate(90deg)' : 'rotate(0deg)'"
      [style.transition]="'transform 0.2s ease'"
    >
      <path 
        d="M9 18L15 12L9 6" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
    </svg>
  </button>
</ng-template>

<!-- Child Row Template -->
<ng-template #assetRequestChildRow let-row>
  <tr class="table--child-row">
    <td [attr.colspan]="assetRequestColumns.length" class="table--child-cell">
      <div class="child-row-content">
        <div class="child-row-grid">
          <div class="child-row-item">
            <span class="child-row-label">Consumer Name</span>
            <span class="child-row-value">{{ row.requestedBy || 'N/A' }}</span>
          </div>
          <div class="child-row-item">
            <span class="child-row-label">Consumer Email</span>
            <span class="child-row-value">{{ row.consumerEmail || 'N/A' }}</span>
          </div>
          <div class="child-row-item child-row-item--purpose">
            <span class="child-row-label">Purpose</span>
            <span class="child-row-value">{{ row.purpose || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </td>
  </tr>
</ng-template>

<app-table
  [columns]="assetRequestColumns"
  [data]="assetRequestData"
  [pagination]="assetRequestPagination"
  [loading]="assetRequestLoading"
  [emptyMessage]="assetRequestEmptyMessage"
  [dropdownOpenRowIndex]="openAssetRequestDropdownRowIndex"
  [childRowTemplate]="assetRequestChildRowTemplate"
  [isRowExpanded]="getIsRowExpanded()"
  [initialSortColumn]="currentSort.field"
  [initialSortDirection]="currentSort.order"
  (pageChange)="onAssetRequestPageChange($event)"
  (pageSizeChange)="onAssetRequestPageSizeChange($event)"
  (sortChange)="onAssetRequestSortChange($event)"
>
  <!-- Asset Status column: chips -->
  <ng-template #assetRequestStatusCell let-row>
    <span [ngClass]="getStatusChipClass(row.assetStatus)" class="contribution-chip-wrap">
      {{ getStatusLabel(row.assetStatus) }}
    </span>
  </ng-template>
  <!-- Published On: DD-MMM-YYYY -->
  <ng-template #assetRequestPublishedOnCell let-row>
    {{ formatPublishedOn(row.publishedOn) }}
  </ng-template>
  <!-- Custom Action Column -->
  <ng-template #assetRequestActionCell let-row>
    <div class="action-cell-wrapper" [class.action-dropdown-open]="isDropdownOpen(row)">
      <button 
        class="action-btn action-btn--primary" 
        appActionDropdownTrigger
        (click)="toggleActionDropdown($event, row)"
        [class.active]="isDropdownOpen(row)"
        type="button"
      >
        <span class="action-btn-label">Action</span>
        <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      <div 
        class="action-dropdown-menu action-dropdown-menu--fixed" 
        *ngIf="isDropdownOpen(row)" 
        [style.top.px]="dropdownPosition.top"
        [style.left.px]="dropdownPosition.left"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item">
            <button 
              class="dropdown-link" 
              [class.disabled]="isActionDisabled(row)"
              [disabled]="isActionDisabled(row)"
              (click)="handleAction('approve', row)"
            >Approve</button>
          </li>
          <li class="dropdown-item">
            <button 
              class="dropdown-link" 
              [class.disabled]="isActionDisabled(row)"
              [disabled]="isActionDisabled(row)"
              (click)="handleAction('reject', row)"
            >Reject</button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</app-table>

<!-- Approve asset request modal -->
<app-modal
  [(visible)]="isApproveModalVisible"
  header="Approve Asset Request"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  confirmLabel="Approve"
  cancelLabel="Cancel"
  [confirmButtonDisabled]="!expirationDate?.startDate || !isExpiryValid()"
  (onConfirm)="onApproveConfirm()"
  (onCancel)="closeApproveModal()"
  (onClose)="closeApproveModal()"
>
  <div class="approve-asset-modal approve-asset-modal-content">
    <div class="approve-asset-modal__info">
      <span class="approve-asset-modal__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      </span>
      <p class="approve-asset-modal__description">
        Specify until when this access request should remain valid. The requester will have access to the asset until the selected date and time.
      </p>
    </div>
    <div class="approve-asset-modal__field">
      <label class="approve-asset-modal__label">
        Expiry At <span class="approve-asset-modal__required">*</span>
      </label>
      <div class="approve-asset-modal__date-time-row">
        <app-date-range-picker
          [(ngModel)]="expirationDate"
          [singleDateMode]="true"
          [minDate]="minDate"
          [disableFutureDates]="false"
          placeholder="Select date"
          styleClass="approve-asset-modal-date-picker"
        ></app-date-range-picker>
      </div>
      <span class="approve-asset-modal__hint">Access will be valid until this date and time</span>
    </div>
  </div>
</app-modal>
